import { render } from "./ChatMessage.vue?vue&type=template&id=3e4df3b0"
import script from "./ChatMessage.vue?vue&type=script&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&lang=ts"

import "./ChatMessage.vue?vue&type=style&index=0&id=3e4df3b0&lang=stylus"
script.render = render

export default script